import * as React from 'react'
import type { SVGProps } from 'react'
const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2726 2.20166H18.0838L11.9421 9.22124L19.1673 18.7733H13.51L9.07901 12.98L4.00894 18.7733H1.19601L7.76518 11.2651L0.833984 2.20166H6.63491L10.6401 7.49694L15.2726 2.20166ZM14.2859 17.0906H15.8436L5.78848 3.79594H4.11687L14.2859 17.0906Z"
      fill="#4F5277"
    />
  </svg>
)
export default SvgTwitter
